export default __webpack_public_path__ + "static/media/24.1842eea7.JPG";